import Complete from "./Complete";
import DeleteEntryButton from "./DeleteEntryButton";
import EditObservationEntry from "./EditObservationEntry";
import EditEntry from "./EditTrackerEntry";

export const entryComponents = {
	EditEntry,
	DeleteEntryButton,
	TrackerComplete: Complete,
	EditObservationEntry,
};
